import React, { useEffect, useState } from "react";
import Topbar from "./topBar";
import Sidebar from "./sideBar";
import { Link } from "react-router-dom";
import { toast, Bounce } from "react-toastify";
import Swal, { SweetAlert } from "sweetalert2/dist/sweetalert2.js";
import {
  Box,
  Button,
  Modal,
  Grid,
  TextField,
  Fade,
  Card,
  CardMedia,
  CardContent,
  Typography,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { privateApiCall } from "../../api/privateApi";

const Gallery = () => {
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({
    title: "",
    brochure: "",
  });
  const [fileUrl, setFileUrl] = useState("");
  const [fileType, setFileType] = useState("");
  const [galleryImages, setGalleryImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [viewModal, setViewModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setData({
      title: "",
      brochure: "",
    });
    setSelectedImage(null);
    setShowModal(false);
    setFileType("");
  };

  const loadGallery = async (e) => {
    const requestUrl = "/api/organisation/getGalleryImage";
    const response = await privateApiCall(requestUrl, "GET");
    console.log(response.data.images, "++++");

    setGalleryImages(response.data.images);
  };
  useEffect(() => {
    loadGallery();
  }, []);

  const handleSubmit = async (e) => {
    console.log("submitting");
    e.preventDefault();
    try {
      const requestUrl = "/api/organisation/imageUpload";

      const formData = new FormData();
      formData.append("title", data.title);
      formData.append("brochure", data.brochure);
      const response = await privateApiCall(requestUrl, "POST", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(response, "8888");
      handleCloseModal();
      loadGallery();
      toast.info(response.data.message, {
        position: "top-right",
        transition: Bounce,
      });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleFileUpload = (file) => {
    const fileType = file.type;

    setFileType(fileType);
    setData((prevState) => ({ ...prevState, brochure: file }));
    setFileUrl(URL.createObjectURL(file));
  };
  const handleDeleteImage = async (imageUrl) => {
    try {
      const result = await Swal.fire({
        title: "Do You Want to delete this brochure",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: " #3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No",
      });
      if (result.isConfirmed) {
        const requestUrl = `/api/organisation/deleteImage`;
        const response = await privateApiCall(requestUrl, "DELETE", {
          imageUrl,
        });
        loadGallery();
        toast.error(response.data.message, {
          position: "top-right",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  const handleViewImage = (image) => {
    setSelectedImage(image);
    setViewModal(true);
  };
  const handleCloseViewModal = () => {
    setSelectedImage(null);
    setViewModal(false);
  };

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#0baae5" />
      <Sidebar />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <h4 className="page-title float-left">Your Gallery</h4>
                  <ol className="breadcrumb float-right">
                    <li className="breadcrumb-item">
                      <Link to="/organisation/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Gallery</li>
                  </ol>
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="card-box">
                  <div className="row">
                    <div className="col-12">
                      <div className="p-20">
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#0baae5",
                            color: "#fff",
                            marginBottom: "20px",
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: "#0baae5",
                            },
                          }}
                          onClick={handleShowModal}
                        >
                          + Add Brochure
                        </Button>
                        <Modal
                          open={showModal}
                          onClose={handleCloseModal}
                          closeAfterTransition
                          BackdropProps={{
                            style: {
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                            },
                          }}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          disableBackdropClick
                        >
                          <Fade in={showModal}>
                            <Box
                              sx={{
                                bgcolor: "background.paper",
                                boxShadow: 1,
                                p: 4,
                                borderRadius: 2,
                                width: "60%",
                                marginBottom: "20px",
                              }}
                            >
                              <h2>Add Brochure</h2>
                              <form onSubmit={handleSubmit}>
                                <Grid
                                  container
                                  spacing={2}
                                  style={{ marginTop: "0px" }}
                                >
                                  <Grid item xs={12} sm={6} md={4}>
                                    {fileType.startsWith("image/") ? (
                                      <img
                                        src={fileUrl}
                                        alt="Uploaded"
                                        height="150px"
                                        width="100%"
                                      />
                                    ) : fileType === "application/pdf" ? (
                                      <embed
                                        src={fileUrl}
                                        type="application/pdf"
                                        width="100%"
                                        height="150px"
                                      />
                                    ) : fileType === "application/msword" ||
                                      fileType ===
                                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? (
                                      <a
                                        href={fileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        View Document
                                      </a>
                                    ) : (
                                      <img
                                        src="/assets/icons/try.jpg"
                                        alt=""
                                        height="150px"
                                        width="100%"
                                      />
                                    )}
                                    <div className="mt-3">
                                      <input
                                        type="file"
                                        id="file"
                                        name="brochure"
                                        className="mt-3 mb-3"
                                        onChange={(e) =>
                                          handleFileUpload(e.target.files[0])
                                        }
                                        accept="image/png, image/jpeg,image/jpg, application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                      />
                                    </div>
                                  </Grid>

                                  <Grid item xs={12}>
                                    <TextField
                                      fullWidth
                                      label="Title"
                                      variant="outlined"
                                      placeholder="Enter Title"
                                      name="title"
                                      value={data.title}
                                      onChange={(e) =>
                                        setData({
                                          ...data,
                                          title: e.target.value,
                                        })
                                      }
                                      required
                                    />
                                  </Grid>
                                </Grid>
                                <Grid
                                  container
                                  justifyContent="flex-end"
                                  style={{
                                    marginTop: "40px",
                                    marginBottom: "0px",
                                  }}
                                >
                                  <Button
                                    variant="outlined"
                                    color="error"
                                    style={{ marginRight: "10px" }}
                                    onClick={handleCloseModal}
                                  >
                                    Close
                                  </Button>
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    style={{
                                      backgroundColor: "#0baae5",
                                    }}
                                  >
                                    Add
                                  </Button>
                                </Grid>
                              </form>
                            </Box>
                          </Fade>
                        </Modal>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <Grid container spacing={2}>
                      {galleryImages.map((image) => (
                        <Grid item xs={12} sm={6} md={4} key={image.url}>
                          <Card sx={{ maxHeight: 400 }}>
                            <Box position="relative">
                              {image.url.endsWith(".pdf") ? (
                                <iframe
                                  title="PDF Viewer"
                                  src={image.url}
                                  height="400"
                                  width="100%"
                                />
                              ) : (
                                <CardMedia
                                  component="img"
                                  height="400"
                                  image={image.url}
                                  sx={{ objectFit: "cover" }}
                                />
                              )}
                              <Box
                                position="absolute"
                                top={0}
                                right={0}
                                display="flex"
                                flexDirection="column"
                              >
                                <IconButton
                                  color="primary"
                                  onClick={() => handleViewImage(image)}
                                >
                                  <VisibilityIcon />
                                </IconButton>
                                <IconButton
                                  color="error"
                                  onClick={() => handleDeleteImage(image.url)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Box>
                            </Box>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                  <Modal
                    open={viewModal}
                    onClose={handleCloseViewModal}
                    closeAfterTransition
                    BackdropProps={{
                      style: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                      },
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    disableBackdropClick
                  >
                    <Fade in={viewModal}>
                      <Box
                        sx={{
                          bgcolor: "background.paper",
                          boxShadow: 1,
                          p: 4,
                          borderRadius: 2,
                          width: "60%",
                          marginBottom: "20px",
                         
                        }}
                      >
                        {selectedImage && (
                          <>
                            {selectedImage.url.endsWith(".pdf") ? (
                              <iframe
                                title="PDF Viewer"
                                src={selectedImage.url}
                                style={{
                                  width: "100%",
                                  height: "60vh",
                                  border: "none",
                                }}
                              />
                            ) : (
                              <img
                                src={selectedImage.url}
                                alt={selectedImage.title}
                                style={{
                                  width: "100%",
                                  maxHeight: "60vh",
                                  objectFit: "cover",
                                }}
                              />
                            )}
                            <Typography variant="h6" component="div" mt={2}>
                              Title:{selectedImage.title}
                            </Typography>
                            <Typography variant="h6" color="text.secondary">
                              Uploaded Date:{selectedImage.submittedDate}
                            </Typography>
                          </>
                        )}
                        <Grid
                          container
                          justifyContent="flex-end"
                          style={{
                            marginTop: "40px",
                            marginBottom: "0px",
                          }}
                        >
                          <Button
                            variant="outlined"
                            color="error"
                            style={{ marginRight: "10px" }}
                            onClick={handleCloseViewModal}
                          >
                            Close
                          </Button>
                        </Grid>
                      </Box>
                    </Fade>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
